export const path = "/compao-product";
export const component = () => import("./index.jsx");
export const enabled = false;

export const sidebar = {
  title: "COMPAO PRODUCT",
  section: "COMPAO",
  group: null,
  order: 3,
  roles: [
    "Authenticated",
    "design",
    "design-roundler",
    "roundler-admin",
    "aluna",
  ],
};
